import React, { Component } from "react";
import { Text } from "react-internationalization";
import RaceCds from "./RaceAndEthicCode/RaceCds";
import EthniCity from "./RaceAndEthicCode/EthniCity";
import { connect } from "react-redux";
import { FieldLabel, ilsFormats } from "./translations/dynamic";
import {
  ILS_CONSTS,
  SHARP_CONSTS,
  VERDA_CONSTS,
} from "../Utils/StaticData/Constant";
import PremiumType from "./AllSteps/PremiumTypes/PremiumType";
class PreviewPageStep3 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { data } = this.props;
    let pcpPreview =
      this.props.pcpName !== undefined && this.props.pcpName !== ""
        ? this.props.pcpName
        : this.props.preEnrollInfo?.pcpName
        ? this.props.preEnrollInfo?.pcpName
        : data?.pcpName
        ? data.pcpName
        : "";

    return (
      <div>
        <label class="control-label mt-3">
          <strong>
            <Text id="step4Agent.otherdet" />
            &nbsp;
            <a onClick={this.props.changeToSection3} class="cursor-pointer">
              <i class="fas fa-edit"></i>
            </a>
          </strong>
        </label>
        <div class="form-panel">
          {this.props?.data?.ethnicityRace?.length > 0 ? (
            <>
              <p>
                <strong>
                  A. <Text id="step2.A" />.
                </strong>
              </p>
              <p>
                <strong>
                  <Text id="app.racePara" />
                </strong>
              </p>
              <div class="form-group">
                <RaceCds
                  handleRaceAndEthic={this.props.handleRaceAndEthic}
                  ethnicityRace={this.props.data.ethnicityRace}
                />
              </div>
              <p>
                <strong>
                  <Text id="step2.Quest23" />
                </strong>
              </p>
              <div class="form-group">
                <EthniCity
                  handleRaceAndEthic={this.props.handleRaceAndEthic}
                  ethnicityRace={this.props.data.ethnicityRace}
                />
              </div>
            </>
          ) : null}
          <div class="form-group">
            {/* below block is for vanilla ui only */}
            {this.props?.data?.prefLng === "SPA" &&
            [SHARP_CONSTS.VANILLA_CUSTOMER_ID].some(
              (ids) => ids === this.props?.customerId
            ) ? (
              <div class="display-inline-flex">
                <label for="language" class="control-label mr-2">
                  <Text id="step2.A1" />.
                </label>
                <div class="m-top-0 m-left-2em custom-control1 custom-checkbox">
                  <input
                    type="checkbox"
                    name="prefLng"
                    id="language"
                    class="custom-control-input"
                    value="SPA"
                    disabled
                    checked={this.props.data.prefLng === "SPA"}
                  />
                  <label
                    for="language"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="step2.Spanish" />
                  </label>
                </div>
              </div>
            ) : null}
            {/* Below accessible formats contains code for ILS only*/}
            {ILS_CONSTS.ID === this.props.customerId &&
              this.props?.data?.prefLng !== "" &&
              this.props?.data?.prefLng !== undefined && (
                <fieldset class="radio radio-tab mt-3">
                  <legend>
                    <Text id="step2.A1" />.
                  </legend>
                  {ilsFormats(this.props.language).map((ilsF, ilsId) => (
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        type="radio"
                        name="prefLng"
                        id={ilsF?.id}
                        className="custom-control-input"
                        value={ilsF.value}
                        checked={this.props?.data?.prefLng === ilsF?.value}
                        disabled
                      />
                      <label
                        htmlFor={ilsF?.id}
                        class="radio-inline custom-control-label"
                      >
                        {ilsF?.label.charAt(0) +
                          ilsF?.label.substring(1)?.toLowerCase()}
                      </label>
                    </div>
                  ))}
                  {data?.prefLng === "OTH"
                   && (
                    <input
                      type="text"
                      id="prefLngOthrValue"
                      name="prefLngOthrValue"
                      value={data?.prefLngOthrValue}
                      class={"custom-radio custom-control-inline mt-1 pl-0"}
                      autoComplete="off"
                      style={{ border: "1px solid #999" }}
                      disabled
                    />
                  )
                  }
                </fieldset>
              )}
            {data.accessibleFormatVal === "B" ||
            data.accessibleFormatVal === "L" ||
            data.accessibleFormatVal === "A" ||
            data.accessibleFormatVal === "OTHER" ? (
              <fieldset class="radio radio-tab mt-3">
                <legend>
                  <Text id="step2.A2" />.
                </legend>
                <div class="custom-control custom-radio custom-control-inline mt-1">
                  <input
                    type="radio"
                    name="accessibleFormatVal"
                    id="lfp_braille"
                    class="custom-control-input"
                    value="B"
                    checked={data.accessibleFormatVal === "B"}
                    disabled
                  />
                  <label
                    for="lfp_braille"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="step2.Ar1" />
                  </label>
                </div>
                <div class="custom-control custom-radio custom-control-inline mt-1">
                  <input
                    type="radio"
                    name="accessibleFormatVal"
                    id="lfp_largeprint"
                    class="custom-control-input"
                    value="L"
                    checked={data.accessibleFormatVal === "L"}
                    disabled
                  />
                  <label
                    for="lfp_largeprint"
                    class="radio-inline custom-control-label"
                  >
                    <Text id="step2.Ar2" />
                  </label>
                </div>
                {[VERDA_CONSTS.ID, ILS_CONSTS.ID].some(
                  (ids1) => ids1 === this.props.customerId
                ) && (
                  <div class="custom-control custom-radio custom-control-inline mt-1 other-radio-mobile-aligner">
                    <input
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_other"
                      class="custom-control-input"
                      value="A"
                      checked={data.accessibleFormatVal === "A"}
                      disabled
                    />
                    <label
                      for="lfp_other"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="verda.step3.Ar3" />
                    </label>
                  </div>
                )}
                {[VERDA_CONSTS.ID, ILS_CONSTS.ID].every(
                  (ids2) => ids2 !== this.props.customerId
                ) && (
                  <div class="custom-control custom-radio custom-control-inline mt-1 other-radio-mobile-aligner">
                    <input
                      type="radio"
                      name="accessibleFormatVal"
                      id="lfp_other"
                      class="custom-control-input"
                      value="OTHER"
                      checked={data.accessibleFormatVal === "OTHER"}
                      disabled
                    />
                    <label
                      for="lfp_other"
                      class="radio-inline custom-control-label"
                    >
                      <Text id="step2.Ar3" />
                    </label>
                  </div>
                )}
              </fieldset>
            ) : null}
            <br />
            {/* <p class="medicare-note">
              <Text id="step2.Para1" />
              <a href="tel:1-855-562-8853"> 1-855-562-8853 </a>
              <Text id="step2.Para2" />
            </p> */}
          </div>
          <div class="form-group">
            {this.props.productName !== "Medicare Supplement" ? (
              <>
                {this.props.product != "PDP" ? (
                  <p>
                    <strong>
                      B. <Text id="step2.B" />
                      {this.props.planType === "HMO" ? "*" : ""}
                    </strong>
                  </p>
                ) : null}
                {this.props.product != "PDP" ? (
                  <div class="row mt-3">
                    <div class="col-md-6">
                      {/* <label for="pcpName" class="control-label">
                        <Text id="step2.PCPName" />
                        {this.props.planType === "HMO" ? "*" : ""}

                        <div class="pcp-step3">
                          <p>
                            {this.state?.pcpShown
                              ? ": " + " " + this.state?.pcpShown
                              : this.props?.preEnrollInfo?.pcpName
                              ? ": " + " " + this.props?.preEnrollInfo?.pcpName
                              : ""}
                          </p>
                        </div>
                      </label> */}
                      <p>
                        <Text id="step2.PCPName" />
                        :&nbsp;
                        <strong>
                          {this.props.pcpName !== undefined &&
                          this.props.pcpName !== ""
                            ? this.props.pcpName
                            : this.props.preEnrollInfo?.pcpName
                            ? this.props.preEnrollInfo?.pcpName
                            : data?.pcpName
                            ? data.pcpName
                            : ""}
                        </strong>
                      </p>
                    </div>
                    <div class="col-md-6 assign-pcp-margin">
                      <p>
                        <Text id="step2.MedicalGroup" />
                        :&nbsp;
                        <strong>
                          {pcpPreview && this?.props?.PcpLocationId
                            ? this.props.physiciansData.length > 1
                              ? this.props.physiciansData.filter(
                                  (data1) =>
                                    data1.doctorName +
                                      " " +
                                      "-" +
                                      " " +
                                      data1?.locationId ===
                                    pcpPreview +
                                      " " +
                                      "-" +
                                      " " +
                                      this?.props?.PcpLocationId
                                )[0] !== undefined
                                ? this.props.physiciansData.filter(
                                    (data1) =>
                                      data1.doctorName +
                                        " " +
                                        "-" +
                                        " " +
                                        data1?.locationId ===
                                      pcpPreview +
                                        " " +
                                        "-" +
                                        " " +
                                        this?.props?.PcpLocationId
                                  )[0].clinicName
                                : ""
                              : ""
                            : null}

                          {/* {(this.props.pcpName && this.props.pcpName !== "---Select---" )||  data.pcpName
                                                ? this.props.physiciansData.length > 1
                                                    ? this.props.physiciansData.filter(
                                                        (data1) =>
      
                                                            // this.props.pendingApplFlag
                                                            //   ? data1.label === data.pcpName
                                                            (data1.doctorName &&  this.props.pcpName &&
                                                              data1.doctorName === this.props.pcpName) ||(
                                                               data1.doctorName &&   data.pcpName&&
                                                                data1.doctorName ===  data.pcpName)
                                                            // data1.doctorName === this.props.pcpName|| data1.doctorName ===  data.pcpName
                                                    )[0] !== undefined
                                                        ? this.props.physiciansData.filter(
                                                            (data1) =>
                                                                // this.props.pendingApplFlag
                                                                //   ? data1.label === data.pcpName
                                                                (data1.doctorName &&  this.props.pcpName &&
                                                                  data1.doctorName === this.props.pcpName) ||(
                                                                   data1.doctorName &&   data.pcpName&&
                                                                    data1.doctorName ===  data.pcpName)
                                                                // data1.doctorName === this.props.pcpName || data1.doctorName ===  data.pcpName
                                                        )[0].clinicName
                                                        : ""
                                                    : this.props?.preEnrollInfo?.clinicName?this.props?.preEnrollInfo?.clinicName:""
                                                : this.props.preEnrollInfo && this.props.preEnrollInfo.pcpDetails 
                                                ? this.props.preEnrollInfo.pcpDetails.name
                                                 : ""
                                                 } */}
                        </strong>
                      </p>
                    </div>
                  </div>
                ) : null}
                <div class="row mt-3">
                  {data.isCurrentPatient === "N" ||
                  data.isCurrentPatient === "Y" ? (
                    <div class="col-md-4">
                      <fieldset class="radio radio-tab mt-3">
                        <legend>
                          <Text id="step2.currentpatient" />
                        </legend>

                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            name="isCurrentPatient"
                            id="currentPatient_Y"
                            class="custom-control-input"
                            value="Y"
                            checked={data.isCurrentPatient === "Y"}
                            disabled
                          />
                          <label
                            for="currentPatient_Y"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.Yes" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            name="isCurrentPatient"
                            id="currentPatient_no"
                            class="custom-control-input"
                            value="N"
                            checked={data.isCurrentPatient === "N"}
                            disabled
                          />
                          <label
                            for="currentPatient_no"
                            class="radio-inline custom-control-label"
                          >
                            No
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  ) : null}
                  {data.doYouWork === "N" || data.doYouWork === "Y" ? (
                    <div class="col-md-4">
                      <fieldset class="radio radio-tab mt-3">
                        <legend>
                          <Text id="step2.Dowork" />
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="doYouWork"
                            id="dDoYouWork_Yes"
                            class="custom-control-input"
                            value="Y"
                            checked={data.doYouWork === "Y"}
                            disabled
                          />
                          <label
                            for="dDoYouWork_Yes"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.Yes" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="doYouWork"
                            id="dDoYouWork_No"
                            class="custom-control-input"
                            value="N"
                            checked={data.doYouWork === "N"}
                            disabled
                          />
                          <label
                            for="dDoYouWork_No"
                            class="radio-inline custom-control-label"
                          >
                            No
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  ) : null}
                  {data.isSpouseWork === "Y" || data.isSpouseWork === "N" ? (
                    <div class="col-md-4">
                      <fieldset class="radio radio-tab mt-3">
                        <legend>
                          <Text id="step2.spousework" />
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="isSpouseWork"
                            id="dDoYourSpouseWork_Yes"
                            class="custom-control-input"
                            value="Y"
                            checked={data.isSpouseWork === "Y"}
                            disabled
                          />
                          <label
                            for="dDoYourSpouseWork_Yes"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.Yes" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="isSpouseWork"
                            id="dDoYourSpouseWork_No"
                            class="custom-control-input"
                            value="N"
                            checked={data.isSpouseWork === "N"}
                            disabled
                          />
                          <label
                            for="dDoYourSpouseWork_No"
                            class="radio-inline custom-control-label"
                          >
                            No
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  ) : null}
                  {/* new fields */}
                  {data.premiumType === "A" ||
                  data.premiumType === "D" ||
                  data.premiumType === "W" ? (
                    <div class="col-md-12">
                      <fieldset class="radio radio-tab mt-3">
                        <legend>
                          <Text id="step2.paymentopt" />
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="premiumType"
                            id="month"
                            class="custom-control-input"
                            value="D"
                            checked={data.premiumType === "D"}
                            disabled
                          />
                          <label
                            for="month"
                            class="radio-inline custom-control-label"
                          >
                            {FieldLabel("month", this.props.customerId)}
                            {/* <Text id="app.month" /> */}
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="premiumType"
                            id="autodeduct"
                            class="custom-control-input"
                            value="A"
                            checked={data.premiumType === "A"}
                            disabled
                          />
                          <label
                            for="autodeduct"
                            class="radio-inline custom-control-label"
                          >
                            {FieldLabel("autodeduc", this.props.customerId)}
                            {/* <Text id="app.autodeduc" /> */}
                          </label>
                        </div>
                        {(data.premiumType === "S" ||
                  data.premiumType === "R" ||
                  data.premiumType === "A") && this.props.customerId===ILS_CONSTS.ID ? (
                    <div class="col-md-12">
                      <fieldset class="radio radio-tab mt-3">
                        <legend>
                          <Text id="step2.getmonthlyBenefits" />
                          <strong className="mandatory-field-bold">*</strong>
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="monthlybenefitsfrom"
                            id="S"
                            class="custom-control-input"
                            value="S"
                            checked={data.monthlybenefitsfrom === "S"}
                            disabled
                          />
                          <label
                            for="S"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.SS" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="monthlybenefitsfrom"
                            id="R"
                            class="custom-control-input"
                            value="R"
                            checked={data.monthlybenefitsfrom === "R"}
                            disabled
                          />
                          <label
                            for="R"
                            class="radio-inline custom-control-label"
                          >
                            {/* <Text id="app.RRB" /> */}
                            {FieldLabel("RRB", this.props.customerId)}
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  ) : null}
                        <PremiumType
                          isPreview={true}
                          data={data}
                          customerId={this.props.customerId}
                          handleChange={(e) => {}}
                        />
                      </fieldset>
                    </div>
                  ) : null}
                  {/* new add field */}
                  {(data.premiumType === "S" ||
                  data.premiumType === "R" ||
                  data.premiumType === "A") && this.props.customerId!==ILS_CONSTS.ID ? (
                    <div class="col-md-12">
                      <fieldset class="radio radio-tab mt-3">
                        <legend>
                          <Text id="step2.getmonthlyBenefits" />
                          <strong className="mandatory-field-bold">*</strong>
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="monthlybenefitsfrom"
                            id="S"
                            class="custom-control-input"
                            value="S"
                            checked={data.monthlybenefitsfrom === "S"}
                            disabled
                          />
                          <label
                            for="S"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.SS" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mt-1">
                          <input
                            type="radio"
                            name="monthlybenefitsfrom"
                            id="R"
                            class="custom-control-input"
                            value="R"
                            checked={data.monthlybenefitsfrom === "R"}
                            disabled
                          />
                          <label
                            for="R"
                            class="radio-inline custom-control-label"
                          >
                            {/* <Text id="app.RRB" /> */}
                            {FieldLabel("RRB", this.props.customerId)}
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  ) : null}
                  {/* 2nd field */}
                  {/* <div class="col-md-12">
                        <fieldset class="radio radio-tab mt-3">
                          <legend>
                            <Text id="step2.esrd" />
                          </legend>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="esrdInd"
                              id="haveESRD_Yes"
                              class="custom-control-input"
                              value="Y"
                              checked={data.esrdInd === "Y"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="haveESRD_Yes"
                              class="radio-inline custom-control-label"
                            >
                              <Text id="app.Yes" />
                            </label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="esrdInd"
                              id="haveESRD_No"
                              class="custom-control-input"
                              value="N"
                              checked={data.esrdInd === "N"}
                              onChange={this.props.handleChange}
                            />
                            <label
                              for="haveESRD_No"
                              class="radio-inline custom-control-label"
                            >
                              No
                            </label>
                          </div>
                        </fieldset>
                      </div> */}
                  {/*3rd field */}
                  <div class="form-group">
                    {data.medicaidInd === "Y" || data.medicaidInd === "N" ? (
                      <div class="col-md-12">
                        <fieldset class="radio radio-tab mt-3">
                          <legend>
                            <Text id="step2.smp" />
                          </legend>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="medicaidInd"
                              id="isSMP_Yes"
                              class="custom-control-input"
                              value="Y"
                              checked={data.medicaidInd === "Y"}
                              disabled
                            />
                            <label
                              for="isSMP_Yes"
                              class="radio-inline custom-control-label"
                            >
                              <Text id="app.Yes" />
                            </label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="medicaidInd"
                              id="isSMP_No"
                              class="custom-control-input"
                              value="N"
                              checked={data.medicaidInd === "N"}
                              disabled
                            />
                            <label
                              for="isSMP_No"
                              class="radio-inline custom-control-label"
                            >
                              No
                            </label>
                          </div>
                        </fieldset>
                      </div>
                    ) : null}
                    {data.medicaidInd === "Y" ? (
                      <div class="col-md-12">
                        <div class="custom-control-inline mt-3">
                          <label class="control-label" for="medicaidInd">
                            <Text id="step3.medicaidnumber" />
                            :* &nbsp;
                          </label>
                          <span>
                            <input
                              type="text"
                              name="medicaidId"
                              id="medicaidId"
                              required=""
                              class={"form-control"}
                              maxLength="20"
                              disabled
                              value={data.medicaidId}
                            />
                          </span>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {this.props.agentLoggedIn &&
                    (data.ltcInd === "Y" || data.ltcInd === "N") && (
                      <div class="col-md-12 mb-2">
                        <fieldset class="radio radio-tab mt-3">
                          <legend>
                            <Text id="step2.ltc" />
                          </legend>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="ltcInd"
                              id="isLTC_Yes"
                              class="custom-control-input"
                              value="Y"
                              checked={data.ltcInd === "Y"}
                              disabled
                            />
                            <label
                              for="isLTC_Yes"
                              class="radio-inline custom-control-label"
                            >
                              <Text id="app.Yes" />
                            </label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline mt-1">
                            <input
                              type="radio"
                              name="ltcInd"
                              id="isLTC_No"
                              class="custom-control-input"
                              value="N"
                              checked={data.ltcInd === "N"}
                              disabled
                            />
                            <label
                              for="isLTC_No"
                              class="radio-inline custom-control-label"
                            >
                              No
                            </label>
                          </div>
                        </fieldset>
                      </div>
                    )}
                  {data.ltcInd === "Y" ? (
                    <div class="row ml-3">
                      <div class="col-md-9">
                        {/* <div class="custom-control-inline mt-3"> */}
                        <label class="control-label" for="nameOfInstitution">
                          <Text id="st2cat3.isnt" />
                          :* &nbsp;
                        </label>
                        <select
                          name="nameOfInstitution"
                          id="nameOfInstitution"
                          class={"form-control"}
                          disabled
                          value={data.nameOfInstitution}
                        >
                          {this.props.ltcList.map((item, i) => {
                            return (
                              <option
                                class="select-option"
                                value={item.label?.trim()}
                                key={i}
                              >
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                        {/* </div> */}
                      </div>
                      <div class="col-md-9">
                        {/* <div class="custom-control-inline mt-3"> */}
                        <label class="control-label" for="addrOfInstitution">
                          <Text id="st2cat3.adressint" />
                          :* &nbsp;
                        </label>
                        <span>
                          <input
                            type="text"
                            name="addrOfInstitution"
                            id="addrOfInstitution"
                            required=""
                            class={"form-control"}
                            disabled
                            maxLength="50"
                            value={
                              this.props.ltcList &&
                              this.props.ltcList?.filter((address) =>
                                address.label.includes(data.nameOfInstitution)
                              )[0] != undefined
                                ? this.props.ltcList?.filter((address) =>
                                    address.label.includes(
                                      data.nameOfInstitution
                                    )
                                  )[0].value
                                : ""
                            }
                          />
                        </span>
                        {/* </div> */}
                      </div>
                    </div>
                  ) : null}
                  {/* newfields */}
                </div>
              </>
            ) : null}
            {data.cardioVascular?.length > 0 &&
              (this.props.productId === "TX2B" || data?.productId === "TX2B") &&
              VERDA_CONSTS.ID === this.props.customerId && (
                <div class="row mb-2 pr-2 pl-2">
                  <fieldset
                    class="radio radio-tab mt-3"
                    id="cardioVascular_radio"
                  >
                    <legend>
                      <Text id="verda.cardioVascular" />
                      <strong className="mandatory-field-bold">*</strong>
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        name="cardioVascular"
                        id="cardioVascular_Y"
                        class="custom-control-input"
                        value="Y"
                        checked={data.cardioVascular === "Y" ? true : false}
                      />
                      <label
                        for="cardioVascular_Y"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Yes" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        name="cardioVascular"
                        id="cardioVascular_no"
                        class="custom-control-input"
                        value="N"
                        checked={data.cardioVascular === "N" ? true : false}
                      />
                      <label
                        for="cardioVascular_no"
                        class="radio-inline custom-control-label"
                      >
                        No
                      </label>
                    </div>
                  </fieldset>
                </div>
              )}
            {data.careInd?.length > 0 &&
              VERDA_CONSTS.ID === this.props.customerId && (
                <div class="row mb-2 pr-2 pl-2">
                  <fieldset class="radio radio-tab mt-3">
                    <legend>
                      <Text id="verda.step3.care" />
                      {this.props.customerId === VERDA_CONSTS.ID && (
                        <strong className="mandatory-field-bold">*</strong>
                      )}
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        type="radio"
                        name="careInd"
                        id="care_Yes"
                        class="custom-control-input"
                        value="Y"
                        checked={data.careInd === "Y"}
                      />
                      <label
                        for="care_Yes"
                        class="radio-inline custom-control-label"
                        showCoordination
                      >
                        <Text id="app.Yes" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline mt-1">
                      <input
                        type="radio"
                        name="careInd"
                        id="care_no"
                        class="custom-control-input"
                        value="N"
                        checked={data.careInd === "N"}
                      />
                      <label
                        for="care_no"
                        class="radio-inline custom-control-label"
                      >
                        No
                      </label>
                    </div>
                  </fieldset>
                </div>
              )}
            {data.emailAddress?.length > 0 ? (
              <div class="row mt-3">
                <div class="col-md-12">
                  <label for="clinicName" class="control-label">
                    <Text id="step2.Email" />:
                  </label>
                  <input
                    type="text"
                    id="emailAddress"
                    name="emailAddress"
                    value={data.emailAddress}
                    class={"form-control"}
                    disabled
                  />
                  <div class="checkbox checkbox-tab mt-1">
                  {this.props.customerId===ILS_CONSTS.ID &&
                        <div class="custom-control custom-checkbox custom-control-inline mr-1 pl-0">
                          <span><Text id="ils.step3.emailText1"/></span>
                        </div>
                      }
                    <div class="custom-control custom-checkbox custom-control-inline ml-0">
                      <input
                        type="checkbox"
                        checked={
                          data.emailOptionIndicator === "Y" ? true : false
                        }
                        id="emailAlert"
                        name="emailOptionIndicator"
                        class="custom-control-input"
                        disabled
                      />
                      <label for="emailAlert" class="custom-control-label">
                      {FieldLabel("emailOptionIndicator",this.props.customerId)}
                      </label>
                    </div>
                    {this.props.customerId===ILS_CONSTS.ID &&
                       <div class="custom-control custom-checkbox custom-control-inline ml-1">
                       <input
                         type="checkbox"
                         checked={
                           data?.textIndicator === "Y" ? true : false
                         }
                         id="textIndicator"
                         name="textIndicator"
                         class="custom-control-input"
                         value="Y"
                         disabled
                       />
                       <label for="textIndicator" class="custom-control-label">
                         <Text id="ils.step3.textIndicator" />
                       </label>
                     </div>
                      }
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    physiciansData: state.webApp.physiciansData,
    agentLoggedIn: state.login.agentLoggedIn,
    preEnrollInfo: state.webApp.preEnrollInfo,
    ltcList: state.login.ltcList,
    productId: state.login.productId,
    customerId: state.login.customerId,
    product: state.webApp?.product ? state.webApp?.product : "",
    language: state.webApp.language,
  };
};
export default connect(mapStateToProps)(PreviewPageStep3);
